<template>
    <div>
        <el-drawer
            :visible.sync="showModal" 
            size="50%"
        >   
            <template slot="title">
                <div class="d-flex items-center justify-content-between mr-3">
                    <div class="d-flex align-items-center" :style="{ gap: '8px' }">
                        <el-tag type="warning" class="rounded-circle" effect="dark">
                            <i class="el-icon-date"></i>
                        </el-tag>
                        <h5 class="font-weight-semibold mb-0">Não realização do evento</h5>
                    </div>
                </div>
            </template>

            <div class="px-3">
                <el-form 
                    :model="payload" 
                    ref="eventDenyReason" 
                    label-position="top" 
                    status-icon 
                > 
                    <el-row :gutter="12">
                    
                        <!-- Observacoes -->
                        <el-col>
                            <el-form-item 
                                prop="justificativa"
                                :rules="[{ required: true, message: 'A justificativa é obrigátoria', trigger: 'blur' }]"
                            >
                                <label>Justificativa</label>
                                <el-input
                                    type="textarea"
                                    v-model="payload.justificativa" 
                                    placeholder="Motivo para a não realização do evento"
                                    maxlength="250"
                                    show-word-limit
                                    :rows="5"
                                    :disabled="isLoading"
                                />
                            </el-form-item>
                        </el-col>

                        <!-- Actions -->
                        <el-col>
                            <div class="d-flex align-items-center justify-content-end">
                                <el-form-item>
                                    <el-button 
                                        plain
                                        :disabled="isLoading"
                                        @click="() => {
                                            toggleModal();
                                            resetForm();
                                        }"
                                    >
                                        Cancelar
                                    </el-button>

                                    <el-button 
                                        type="primary"
                                        plain
                                        :disabled="isLoading"
                                        @click="onSubmit"
                                    >
                                        <i v-if="isLoading" class="el-icon-loading"></i>
                                        <i class="fas fa-check-circle"></i>
                                        Salvar
                                    </el-button>
                                </el-form-item>
                            </div>
                        </el-col>
                    </el-row>
                </el-form>
            </div>
        </el-drawer>
    </div>
</template>
<script>
    // Components
    import {
        Loading,
        Row,
        Col,
        Button,
        Input,
        Notification,
        Form, 
        FormItem,
        Tag,
        Drawer
    } from "element-ui";

    // Utis
    import { formattedDiffDate } from "../../util/formatters";

    //Api
    import { AgendaApi } from "@/api/AgendaApi";

    const agendaApi = new AgendaApi();

    export default {
        data() {
            return {
                eventId: null,
                payload: {
                    cumpriu: 'NAO',
                    status: 'NAO CUMPRIU',
                    justificativa: "",
                },
                showModal: false,
                isLoading: false,
            }
        }, 
        methods: {
            onSubmit() {
                this.$refs.eventDenyReason.validate( async (valid) => {
                    if (!valid) {
                        return false
                    } 

                    this.isLoading = true;
                    
                    try {
                        await agendaApi.update(this.payload, this.eventId);

                        Notification.success({
                            title: 'Sucesso',
                            message: 'Evento não foi realizado!',
                            position: 'top-left'
                        });
                    } catch (error) {
                        Notification.error({
                            title: 'Erro',
                            message: 'Não foi possível descumprir o evento!',
                            position: 'top-left'
                        });
                    } finally {
                        this.isLoading = false;
                        this.toggleModal();
                        this.resetForm();
                        this.$emit('dispatch');
                    }
                })
            },
            toggleModal() {
                this.showModal = !this.showModal;
            },
            onModalShown() {
                if (this.$refs.eventDenyReason) {
                    this.resetForm();
                }
            },
            resetForm() {
                this.$refs.eventDenyReason.resetFields();
            },
            formattedDiffDate
        },
        computed: {
            isAuthorized() {
                return this.$store.getters['user/isAnyRole']([
                    'adm',
                    'coord_comercial',
                    'gerente_regional'
                ]);
            },
        },
        components: {
            [Loading.name]: Loading,
            [Row.name]: Row,
            [Col.name]: Col,
            [Notification.name]: Notification,
            [Form.name]: Form,
            [FormItem.name]: FormItem,
            [Input.name]: Input,
            [Button.name]: Button,
            [Drawer.name]: Drawer
        },
    }
</script>


// WEBPACK FOOTER //
// resources/assets/js/components/agenda/EventDenyReason.vue